// @flow
//eslint-disable-next-line

import React from 'react'
import { useSelector } from 'react-redux'

import { CartActions } from '../../../containers'
import { PRODUCT_HELPER } from '../../../utils'

const CartProductWidget = () => {
	const { cart_items } = useSelector((state) => state.cart)
	const products = cart_items?.items

	return products.map((cart_item, i) => {
		return (
			<>
				<div className="cartProductsWrap" key={i}>
					<div className="cartPrdLeft">
						<div className="cartProdImgWrap">
							<img
								src={PRODUCT_HELPER.PRODUCT_IMAGE(cart_item?.product).src}
								alt={PRODUCT_HELPER.PRODUCT_IMAGE(cart_item?.product).alt}
							/>
						</div>
					</div>
					<div className="cartPrdCntr">
						<span className="cartProdName">
							{PRODUCT_HELPER.FORMAT_PRODUCT_NAME(cart_item?.product)}
						</span>
						<span className="cartAddNotes">
							{PRODUCT_HELPER.DISPLAY_ADDITIONAL_NOTES(cart_item?.product, false)}
						</span>
						<div className="slideProdPrice suggestPrice strikeText">
							{PRODUCT_HELPER.FORMAT_PRICE(cart_item?.product)}
						</div>
						<div className="slideProdPrice newPrice">
							{PRODUCT_HELPER.FORMAT_DISCOUNTED_PRICE(cart_item?.product)}
						</div>
					</div>
					<div className="cartPrdRight">
						<CartActions product={cart_item?.product} key={i} />
					</div>
				</div>
				{i < cart_items.count - 1 ? <hr key={i} /> : ''}
			</>
		)
	})
}

export default CartProductWidget
